import { render, staticRenderFns } from "./ChangePaymentMethod.vue?vue&type=template&id=fb557282&scoped=true&"
import script from "./ChangePaymentMethod.vue?vue&type=script&lang=ts&"
export * from "./ChangePaymentMethod.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePaymentMethod.vue?vue&type=style&index=0&id=fb557282&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb557282",
  null
  
)

export default component.exports